"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-toggle";
//#region src/components/atoms/Toggle/Toggle.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "toggle",
	...e,
	ref: r
}));
r.displayName = "Toggle";
//#endregion
export { r as Toggle };
